<template>
  <div class="character transfer__wrapper" :class="{ 'is-packs': isPacks }">
    <form-layout
      :small-title="true"
      :mobile-title="mobileTitle"
      :main-title="title"
      :title="$t('transfer.charactersTitle')"
      :sub-title="$t('transfer.charactersSubTitle')"
      @back="goBack"
      @submit="changeModal"
    >
      <div class="transfer__form">
        <div class="transfer__form-content">
          <Input
            v-model.trim="nickname"
            icon="/base/user.svg"
            :placeholder="$t('transfer.nickname')"
            :state="error ? 'error' : 'default'"
            @input="findUsers"
          />

          <!-- Паки: согласие на передачу данных аккаунта + пояснение, зачем они -->
          <div v-if="isPacks" class="transfer__form-consent">
            <Checkbox v-model="isConsentGiven" :label="$t('packs.consent.label')" />
            <Hint :text="$t('packs.consent.hint')" :size="18" />
          </div>

          <RecentAccounts :roblox-nickname="nickname" @onSelect="selectRecentUser" />
          <div class="transfer__form-characters">
            <Loader v-if="!isLoadedTransfer" />

            <div v-if="charactersLength" class="transfer__form-characters-list" :class="{ 'with-scroll': withScroll }">
              <BaseCard
                v-for="(value, key) in characters"
                :key="key"
                :title="value.name"
                :image="value.imageUrl"
                :active="value.name === choosedNickname"
                @click="selectCharacter(key, value.name)"
              />
            </div>

            <div v-else class="transfer__form-characters-not">
              <p>{{ $t('transfer.notFound') }}</p>
            </div>
          </div>
        </div>
      </div>
    </form-layout>
  </div>
</template>

<script>
import Loader from '@/components/LoaderBar/LoaderBar'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import Input from '@/components/Base/Input/Input.vue'
import RecentAccounts from '@/components/RecentAccounts/RecentAccounts.vue'
import BaseCard from '@/components/BaseCard/BaseCard.vue'
import Hint from '@/components/Base/Hint/Hint.vue'
import Checkbox from '@/components/Base/Checkbox/Checkbox.vue'

export default {
  name: 'TransferCharacters',
  components: {
    BaseCard,
    Input,
    FormLayout,
    Loader,
    RecentAccounts,
    Hint,
    Checkbox
  },
  props: ['isSuperPass', 'isPacks'],

  data() {
    return {
      isLoadedTransfer: true,
      robloxUserId: '',
      nickname: '',
      choosedNickname: '',
      isFilled: false,
      characters: [],
      interval: null,
      error: false,
      // Паки: без согласия на передачу данных аккаунта дальше не пускаем
      isConsentGiven: false
    }
  },
  computed: {
    title() {
      if (this.isPacks) return this.$t('packs.title')
      return this.isSuperPass ? this.$t('superPass.purchase.title') : this.$t('transfer.title')
    },
    mobileTitle() {
      if (this.isPacks) return this.$t('packs.titleMobile')
      return this.isSuperPass ? this.$t('superPass.purchase.title') : this.$t('transfer.titleMobile')
    },
    checked() {
      return this.robloxUserId
    },
    charactersLength() {
      return this.characters.length || Object.keys(this.characters).length
    },
    withScroll() {
      return this.charactersLength >= 3
    }
  },
  methods: {
    changeModal() {
      this.error = false

      if (!this.checked) {
        this.error = true

        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('transfer.errors.emptyCharacters'),
          type: 'error'
        })
        return
      }

      if (this.isPacks && !this.isConsentGiven) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('packs.errors.consent'),
          type: 'error'
        })
        return
      }
      const modal = this.isPacks ? 'PacksPayment' : this.isSuperPass ? 'SuperPassPurchase' : 'TransferPrivatPlace'
      const event = this.isPacks
        ? 'purch_packs_2_nickname'
        : this.isSuperPass
          ? 'purch_super_3_nickname'
          : 'purch_trans_2_nickname'

      this.$store.commit('setScipGamepass', false)
      this.$analytics.send(event, {})

      this.$emit('changeModal', {
        modal,
        data: [this.robloxUserId, this.choosedNickname]
      })
    },
    goBack() {
      const modal = this.isPacks ? 'MainForm' : this.isSuperPass ? 'SuperPassPasses' : 'MainForm'
      this.$emit('changeModal', {
        modal,
        data: [this.robloxUserId, this.choosedNickname]
      })
    },
    selectCharacter(id, nickname) {
      this.robloxUserId = id
      this.choosedNickname = nickname
      this.$store.commit('paymentsOrder/setRobloxData', {
        nickname: nickname,
        userId: id
      })
    },
    setFirstCharacter() {
      const keys = Object.keys(this.characters)

      if (keys?.length > 0) {
        const firstKey = keys[0]
        const firstCharacter = this.characters[firstKey]
        const { name } = firstCharacter

        this.selectCharacter(firstKey, name)
      }
    },
    findUsers() {
      this.error = false
      clearTimeout(this.interval)

      this.interval = setTimeout(() => {
        if (this.nickname.length < 3) {
          this.characters = []
          return
        }

        this.isLoadedTransfer = false

        fetch(`https://transfer.backend-pier.com/search_users/${this.nickname}`)
          .then(res => res.json())
          .then(data => {
            this.isLoadedTransfer = true

            if (data.status) {
              this.characters = data.data
              this.setFirstCharacter()
            } else {
              this.characters = []
            }
          })
          .catch(err => console.log(err))
      }, 1000)
    },
    selectRecentUser(nickname) {
      this.nickname = nickname
      this.findUsers()
    }
  }
}
</script>
<style lang="scss">
@import './transferCharacters';
</style>
